import { motion } from "framer-motion";
import { Award, Trophy, Medal, Star } from "lucide-react";
import { AWARD_HIGHLIGHTS, AWARD_DATES, IMAGES } from "@/data/site";

const icons = [Trophy, Award, Medal, Star];

export const Awards = () => {
  return (
    <section id="awards" data-testid="awards-section" className="bg-[#F8F9FA] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-[#C8102E]">Proven Results. Real Recognition.</p>
          <h2 className="mt-4 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight uppercase text-[#0A0A0A] leading-[0.95]">
            A trusted automotive professional with the numbers to back it up.
          </h2>
          <p className="mt-6 text-base lg:text-lg text-gray-600 leading-relaxed">
            When you work with <span className="text-[#C8102E] font-semibold">Malcolm</span>, you're not guessing. You're working with a proven automotive professional recognized for performance, consistency, and customer service.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative rounded-sm overflow-hidden shadow-2xl shadow-black/10 border border-black/5 bg-[#0A0A0A]"
          >
            <img src={IMAGES.trophy} alt="Malcolm Burke's sales awards and Award of Excellence" className="w-full h-[420px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <p className="font-heading text-2xl font-bold uppercase text-white tracking-tight">Award of Excellence</p>
              <p className="text-sm text-gray-200">Recognized for sales performance and customer service</p>
            </div>
          </motion.div>

          <div className="space-y-6">
            <div className="flex flex-wrap gap-2" data-testid="award-dates">
              {AWARD_DATES.map((d) => (
                <span key={d} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-sm bg-white border border-gray-100 shadow-sm text-xs font-medium text-gray-700">
                  <Medal size={13} className="text-[#C8102E]" /> {d}
                </span>
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {AWARD_HIGHLIGHTS.map((a, i) => {
              const Icon = icons[i % icons.length];
              return (
                <motion.div
                  key={a.label}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1, duration: 0.5 }}
                  data-testid={`award-card-${i}`}
                  className="bg-white border border-gray-100 shadow-xl shadow-black/5 rounded-sm p-7 hover:-translate-y-1 transition-transform"
                >
                  <Icon className="text-[#C8102E]" size={28} />
                  <div className="mt-4 font-heading text-3xl font-bold text-[#0A0A0A] tracking-tight">{a.value}</div>
                  <p className="mt-1 text-sm text-gray-600 leading-snug">{a.label}</p>
                </motion.div>
              );
            })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
